import React from 'react';
import { useGlobal } from '../../../../contexts/Global/context';
import * as S from './styles';

const CustomStatusTag = ({ status }) => {
    const { contrastTheme } = useGlobal();

    const statusTag = [
        {
            id: 2,
            name: 'Rascunho',
            color: contrastTheme ? '#FFFFFF' : '#0B7EB5',
            backgroundColor: contrastTheme ? '#000000' : '#0B7EB510',
        },
        {
            id: 3,
            name: 'Em análise',
            color: contrastTheme ? '#FFFFFF' : '#5B5B5F',
            backgroundColor: contrastTheme ? '#000000' : '#5B5B5F1A',
        },
        {
            id: 4,
            name: 'Recusado',
            color: contrastTheme ? '#FFFFFF' : '#EC130F',
            backgroundColor: contrastTheme ? '#000000' : '#EC130F1A',
        },
        {
            id: 5,
            name: 'Em autorização',
            color: contrastTheme ? '#FFFFFF' : '#5B5B5F',
            backgroundColor: contrastTheme ? '#000000' : '#5B5B5F1A',
        },
        {
            id: 6,
            name: 'Enviado',
            color: contrastTheme ? '#FFFFFF' : '#0B7EB5',
            backgroundColor: contrastTheme ? '#000000' : '#0B7EB510',
        },
        {
            id: 7,
            name: 'Pendente Ajuste',
            color: contrastTheme ? '#FFFFFF' : '#EC130F',
            backgroundColor: contrastTheme ? '#000000' : '#EC130F1A',
        },
    ];

    let dataStatusGroup = statusTag.find((tag) => tag.id === status);

    if (!dataStatusGroup) {
        dataStatusGroup = {
            color: contrastTheme ? '#FFFFFF' : '#000000',
            backgroundColor: contrastTheme ? '#000000' : '#5B5B5F1A',
        };
    }

    return (
        <>
            <S.CustomStatusTagContainer
                colorStatus={dataStatusGroup.color}
                backgroundStatus={dataStatusGroup.backgroundColor}
            >
                {dataStatusGroup.name}
            </S.CustomStatusTagContainer>
        </>
    );
};

export default CustomStatusTag;
